module.exports = __webpack_public_path__ + "media/images/favicon-e43e8bdaf22bc2a6de1aa1a49913f5a5.png";